import { Component, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { DataSource } from '@angular/cdk/collections';
import { LogoRenderComponent } from './../logo-render/logo-render.component';
import { CercaService } from '../cerca.service';

@Component({
  selector: 'app-cercador-esplais',
  templateUrl: './cercador-esplais.component.html',
  styleUrls: ['./cercador-esplais.component.css']
})
export class CercadorEsplaisComponent implements OnInit {

  settings = {
    noDataMessage: 'No s\'han trobat esplais amb la teva cerca :(',
    actions: {
      add: false,
      edit: false,
      delete: false
    },
    columns: {
      logo: {
        title: 'Logo',
        type: 'custom',
        renderComponent: LogoRenderComponent,
        filter: false,
        width: '10%'
      },
      nom: {
        title: 'Nom de l\'esplai',
        filter: false,
      },
      localitat: {
        title: 'Localitat',
        filter: false,
      },
      tel: {
        title: 'Telèfon',
        filter: false,
      },
      email: {
        title: 'Adreça email',
        filter: false,
      },
      web: {
        title: 'Pàgina web',
        filter: false,
        type: 'html',
        valuePrepareFunction: (c) => {
          if (c) {
            return `<a target="_blank" href="http://${c}">Anar a la Web</a>`;
          } else {
            return 'Sense web';
          }
        }
      }
    }
  };

  termeNom;
  termePoblacio;
  termeSector;

  loading = false;
  sectors = [];

  source: LocalDataSource = new LocalDataSource();

  constructor( private service: CercaService) {
    this.service.getDropdown().subscribe(d => {
      this.sectors = d;
    }, e => {
      console.error(e);
    });
   }

 /* JA NO S?UTILITZA
  searchNom() {
    if (this.termeNom) {
      this.loading = true;
      this.service.cercaEsplais('nom', this.termeNom).subscribe(d => {
        this.source.load(d);
        this.loading = false;
        scroll();
      }, err => {
        console.error(err);
        this.loading = false;
      });
    }
  }

  searchPoblacio() {
    if (this.termePoblacio) {
      this.loading = true;
      this.service.cercaEsplais('poblacio', this.termePoblacio).subscribe(d => {
        this.source.load(d);
        this.loading = false;
        scroll();
      }, err => {
        console.error(err);
        this.loading = false;
      });
    }
  }

  searchSector() {
    if (this.termeSector) {
      this.loading = true;
      this.service.cercaEsplais('sector', this.termeSector).subscribe(d => {
        this.source.load(d);
        this.loading = false;
        scroll();
      }, err => {
        console.error(err);
        this.loading = false;
      });
    }
  }
*/
  searchUnificat(){
      this.loading = true;
      let arr = {
        nom: '',
        poblacio: '',
        sector: '',
      };
      if(this.termeNom) arr.nom = this.termeNom;
      if(this.termePoblacio)arr.poblacio = this.termePoblacio;
      if(this.termeSector)arr.sector = this.termeSector;
      this.service.cercaEsplaisUnificat(arr).subscribe(d => {
        this.source.load(d);
        this.loading = false;
        scroll();
      }, err => {
        console.error(err);
        this.loading = false;
      })
    
  }

  ngOnInit() {
    this.searchUnificat();
  }
 
}

async function scroll(){
  await delay(500);
  document.getElementById('results-container').scrollIntoView();
}

function delay(ms: number) {
  return new Promise( resolve => setTimeout(resolve, ms) );
}
